import { InputTypes, ValueTypes, IFormConfig } from 'app/interfaces';
import { cloneFieldDefinition } from 'app/helpers/field.helper';
import nationCodeField from 'app/configs/commons/shared-field-configs/nation-code.field';
import { IDataContainerService } from 'app/interfaces/data-container.interface';
import { Validators } from '@angular/forms';


export default {
	fields: [
		{
			key: 'domain_id',
			name: 'Dominio',
			appearance: 'legacy',
			inputType: InputTypes.DATASET_SELECT,
			valueType: ValueTypes.STRING,
			formValidators: [ Validators.required ],
			datasetCode: 'domains',
			remoteOptions: {
				getParams(dataContainerService: IDataContainerService, record: any) {
					return {enabled: 1};
				},
				getLabel(option): any{
					if(!option) return '';
					return option.display_name;
				},
				getValue(option): any{
					if(!option) return null;
					return option.id;
				},
				getDisplay(option): any{
					if(!option) return '';
					return option.display_name;
				}
			}
		},
	]
} as IFormConfig;
